import { Select, Space } from 'antd';

export default function FilterBar({ filters, active, onChange }) {
  const handleChange = (key, value) => {
    const next = { ...active, [key]: value };
    if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
      delete next[key];
    }
    onChange(next);
  };

  return (
    <Space wrap size="small">
      <Select
        mode="multiple"
        placeholder="BU"
        style={{ minWidth: 90 }}
        value={active.BU}
        onChange={(v) => handleChange('BU', v)}
        options={(filters.BU || []).map(b => ({ label: b, value: b }))}
        allowClear
        maxTagCount={1}
      />
      <Select
        mode="multiple"
        placeholder="产品线"
        style={{ minWidth: 140 }}
        value={active.product}
        onChange={(v) => handleChange('product', v)}
        options={(filters.products || []).map(p => ({
          label: (p || '').length > 25 ? (p || '').slice(0, 25) + '...' : p,
          value: p,
        }))}
        allowClear
        maxTagCount={1}
      />
      <Select
        mode="multiple"
        placeholder="合作状态"
        style={{ minWidth: 100 }}
        value={active.coop_status}
        onChange={(v) => handleChange('coop_status', v)}
        options={(filters.cooperation_statuses || []).map(s => ({ label: s, value: s }))}
        allowClear
        maxTagCount={1}
      />
      <Select
        mode="multiple"
        placeholder="经销商类型"
        style={{ minWidth: 110 }}
        value={active.dealer_type}
        onChange={(v) => handleChange('dealer_type', v)}
        options={(filters.dealer_types || []).map(t => ({ label: t, value: t }))}
        allowClear
        maxTagCount={1}
      />
      <Select
        placeholder="年份"
        style={{ minWidth: 80 }}
        value={active.year}
        onChange={(v) => handleChange('year', v)}
        options={(filters.years || []).map(y => ({ label: String(y), value: y }))}
        allowClear
      />
    </Space>
  );
}
